import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import StickyMobileCTA from '@/components/StickyMobileCTA';
import HeroRecruiting from '@/components/recruiting/HeroRecruiting';
import StatsBar from '@/components/recruiting/StatsBar';
import WasWirMachen from '@/components/recruiting/WasWirMachen';
import BenefitsSection from '@/components/recruiting/BenefitsSection';
import TeamSection from '@/components/recruiting/TeamSection';
import ProcessSteps from '@/components/recruiting/ProcessSteps';
import FAQSection from '@/components/recruiting/FAQSection';
import BewerbungCTA from '@/components/recruiting/BewerbungCTA';
import TeamMomente from '@/components/recruiting/TeamMomente';
import TeamMomenteStrip from '@/components/recruiting/TeamMomenteStrip';

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <SEO
        title="Karriere als Financial Consultant"
        description="Karriere als Financial Consultant bei Hauptstadt Consulting Partners: Baue mit uns einen der größten Finanzberatungsstandorte Berlins auf und bewirb dich jetzt in zwei Minuten."
        canonical="/"
      />
      <Header />
      <main>
        <HeroRecruiting />
        <TeamMomenteStrip />
        <StatsBar />
        <WasWirMachen />
        <BenefitsSection />
        <TeamSection />
        <TeamMomente />
        <ProcessSteps />
        <FAQSection />
        <BewerbungCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default Index;
